<script lang="ts">
  // Stores
  import CurrentRetailerStore from "@retailer/svelte/stores/CurrentRetailerStore";
  import layoutStore from "@shared/svelte/Stores/LayoutStore";

  // Types
  import type { CartOrderType } from "@shared/types/Cart";

  // Props
  export let order: CartOrderType;
  export let cartService: any; // Angular service
  export let showLoading: boolean = false;

  const updatePONumber = () => {
    showLoading = true;

    const res = cartService.updateOrderPONumber(order);
    waitToLoad(res);
  };

  const handleCheck = (event: any, attr: "split_invoices" | "cash_on_delivery") => {
    let params = {};
    params[attr] = event.target.checked;
    showLoading = true;

    const res = cartService.updateOrder(params, order.id);
    waitToLoad(res);
  };

  const waitToLoad = res => Promise.resolve(res).then(() => (showLoading = false));

  $: show =
    !$CurrentRetailerStore?.has_punchout ||
    order.distributor.sf_uses_split_invoices ||
    order.distributor.sf_uses_cash_on_delivery;
</script>

{#if show}
  <div class="fizz-border-bottom fizz-horizontal-16" data-testid="sf-fields-{order.id}">
    <div class="fizz-flex-row-responsive fizz-space-between fizz-inset-square-16">
      <div class="fizz-flex-item fizz-flex-row-24 fizz-flex-row-responsive">
        {#if order.distributor.sf_uses_split_invoices}
          <div class:fizz-flex-item={$layoutStore.isMobile}>
            <label class="fizz-flex-row-8" for="split_invoices_{order.id}">
              <input
                id="split_invoices_{order.id}"
                type="checkbox"
                class="fizz-checkbox"
                data-testid="split_invoices_{order.id}"
                bind:checked={order.split_invoices}
                on:change={e => handleCheck(e, "split_invoices")}
              />
              <span>Separate invoice</span>
            </label>
          </div>
        {/if}

        {#if order.distributor.sf_uses_cash_on_delivery}
          <div class:fizz-flex-item={$layoutStore.isMobile}>
            <label class="fizz-flex-row-8" for="cash_on_delivery_{order.id}">
              <input
                id="cash_on_delivery_{order.id}"
                type="checkbox"
                class="fizz-checkbox"
                data-testid="cash_on_delivery_{order.id}"
                bind:checked={order.cash_on_delivery}
                on:change={e => handleCheck(e, "cash_on_delivery")}
              />
              <span>Cash on delivery</span>
            </label>
          </div>
        {/if}
      </div>
      {#if !$CurrentRetailerStore?.has_punchout}
        <div>
          <label class="fizz-label fizz-stack-4" for="po_number_input">PO Number</label>
          <input
            class="fizz-input-text fizz-input-small fizz-full-width"
            id="po_number_input"
            data-testid="po_number_input"
            bind:value={order.po_number}
            on:blur={updatePONumber}
          />
        </div>
      {/if}
    </div>
  </div>
{/if}
